module.exports = __webpack_public_path__ + "static/centaur-6789b10a84facc179beb3db66d425547.jpg";